// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"095409d4","222":"18f4b9a1","408":"eb081362","453":"20359781","742":"475c6d99","828":"b2c70a88","985":"21f48fca"}[chunkId] + ".chunk.js";
};